// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__30Kgc","title":"BackImages_title__lNccx","images":"BackImages_images__1R75y"};